function redirectIfNotInFrame() {
	if (window.self === window.top) {
		window.location = `${window.appData.appPath}/signin`;
	}
}

export default redirectIfNotInFrame;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/redirectIfNotInFrame.js